import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    workScroll: 0,
    researchScroll: 0
  },
  mutations: {
    setWorkScroll(state, scroll) {
      state.workScroll = scroll
    },
    setResearchScroll(state, scroll) {
      state.researchScroll = scroll
    }
  },
  getters: {
    getWorkScroll: state => {
      return state.workScroll
    },
    getResearchScroll: state => {
      return state.researchScroll
    }
  }
})
